import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { DBPriceRule } from '../../models/stack9/PriceRule';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

const S9Button = ui.S9Button.default;
const { useRefreshList, Space } = ui;

export const config: S9ComponentConfig = {
  name: 'PriceRuleDrawerAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type PriceRuleDrawerActionProps = {
  row: Partial<DBPriceRule>;
};

const PriceRuleDrawerAction = ({ row }: PriceRuleDrawerActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  const formFields = [
    { field: 'organisation_size' },
    { field: 'currency' },
    { field: 'amount', prefix: '$', colSize: 6 },
    { field: 'period_start_dt' },
    { field: 'period_end_dt' },
  ];
  return (
    <>
      {row.id ? (
        <S9Button
          type="link"
          style={{ width: '100%', textAlign: 'left' }}
          onClick={() => setIsOpen(true)}
          label={`${row.organisation_size}`}
        />
      ) : (
        <Space>
          <S9Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      )}
      <EntityDrawer
        title="price rule"
        id={row?.id}
        open={isOpen}
        formFields={formFields}
        initialValues={row}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
        screenQueryName={EDetailsQueryNames.GetPriceRuleDetails}
        entityName={entityNames.PRICE_RULE}
        editRoute={AppRoutes.CountrySetupDetail}
        relativePath={AppRoutes.CountrySetupDetail}
      />
    </>
  );
};

export default PriceRuleDrawerAction;
